var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalRefResidentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01178 12.4049L8.14662 12.405L8.44825 12.406C10.7537 12.4211 16.0224 12.6534 16.0224 16.2155C16.0224 19.7542 10.9374 19.9849 8.48419 20L7.57528 20C5.26967 19.9849 0 19.7528 0 16.1952C0 12.6521 5.26967 12.421 7.57528 12.406L7.87693 12.405C7.92373 12.4049 7.96871 12.4049 8.01178 12.4049ZM8.01178 14.1917C5.1744 14.1917 1.79128 14.5395 1.79128 16.1952C1.79128 17.8135 4.97247 18.1918 7.75244 18.2133L8.01178 18.2143C10.8492 18.2143 14.2311 17.8677 14.2311 16.2155C14.2311 14.5431 10.8492 14.1917 8.01178 14.1917ZM8.01178 0C11.0211 0 13.468 2.44191 13.468 5.44249C13.468 8.44306 11.0211 10.885 8.01178 10.885H7.97953C6.52263 10.8802 5.15768 10.3108 4.13546 9.28165C3.11085 8.25366 2.55078 6.88858 2.5567 5.43891C2.5567 2.44191 5.00363 0 8.01178 0ZM8.01178 1.78677C5.99122 1.78677 4.348 3.42702 4.348 5.44249C4.34444 6.41925 4.71941 7.33288 5.40607 8.02258C6.09272 8.71227 7.00747 9.09464 7.98192 9.09821L8.01178 9.99159V9.09821C10.0323 9.09821 11.6767 7.45915 11.6767 5.44249C11.6767 3.42702 10.0323 1.78677 8.01178 1.78677Z",
    fill: "#39A2DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalRefResidentIcon);
export default __webpack_public_path__ + "static/media/ExternalRefResidentIcon.e9a5ecb22a8626da6284147bba856422.svg";
export { ForwardRef as ReactComponent };